import { i18next, defaultNS } from '@mysaiva/core/i18next'
import en from './locales/en_translation.json'

// Add shell app translations to i18next instance from core
i18next.addResourceBundle('en', defaultNS, en, true, false)

export { i18next }
